import React, { useRef } from 'react';
import { Dropdown, DropdownChangeParams } from 'primereact/dropdown';
import { ILongProps } from "../../../utils/cellInterfaces";

export default function Long(props: ILongProps) {
    const convertToNumber = (value: string) => {
        return parseInt(value);
    }

    const onSelect = (e: DropdownChangeParams) => {
        // TODO handle if invalid value passed(string, chars, symbols)
        props.changeHandler(convertToNumber(e.value));
    }

    const handleChangeValue = (value: any) => {
        if (!isNaN(value) && value !== null && value !== undefined) {
            if (value.includes('.') || value.includes(',')) {
            } else {
                props.changeHandler(value);
            }
        }
    }

    const myRef = useRef(null);

    const onClick = () => {
        if (myRef) {
            // @ts-ignore
            myRef.current.focus();
        }
    }

    const onFocus = (e: any) => {
        e.target.select()
    }

    if (props.isInEditMode) {
        if (props.selectionValues && props.selectionValues.length > 0) {
            return <Dropdown
                style={{ width: '100%', textAlign: 'left' }}
                value={props.value}
                options={props.selectionValues}
                placeholder={String(props.value)}
                onChange={(e) => onSelect(e)}
                required />
        } 
            return <div className="p-inputtext p-d-flex p-jc-between" style={{ padding: '0' }} onClick={() => onClick()}>
                    <input ref={myRef}
                           className="p-inputtext"
                           style={{ border: 'none', width: '100%' }}
                           value={props.value}
                           onChange={(e) => handleChangeValue(e.target.value)}
                           onFocus={onFocus}
                           inputMode='numeric'
                    />
                    {
                        props.unit && props.unit.replaceAll(' ', '') && <label style={{ padding: '12px' }}>
                            {` ${  props.unit}`}
                        </label>
                    }
                </div>
        
    } 
        return <div className="p-inputtext" style={{ border: 'none', whiteSpace:"nowrap", backgroundColor: "transparent", color:"inherit"}}>
            {`${new Intl.NumberFormat('lt-LT').format(props.value)  } ${  props.unit}`}
        </div>
    
}